import { User } from './class/User.js';
import { FlashMessage } from '@osimatic/core-js/widgets/FlashMessage';
import { Locale } from '@osimatic/core-js/location/Locale';
import { TimeZone } from '@osimatic/core-js/calendar/TimeZone';
import { Currency } from '@osimatic/core-js/number/Currency';
import { TelephoneNumber } from '@osimatic/core-js/contact/TelephoneNumber';
import { Country } from '@osimatic/core-js/location/Country';
import { JwtSession } from '@osimatic/core-js/auth/JwtSession';
import { HTTPClient } from '@osimatic/core-js/network/HTTPClient';
import { GoogleRecaptcha } from '@osimatic/core-js/auth/GoogleRecaptcha';

window.checkAccountEnabled = function(modal) {
	if (!User.isAccountEnabled()) {
		FlashMessage.displayError(labelErrorAccountDisabled, modal);
		return false;
	}
	return true;
};

// Initialize locale-dependent formatters
Locale.setDefault('fr-FR');
TimeZone.setDefault(User.getTimeZone() || 'Europe/Paris');
Currency.setDefault(User.getCurrency() || 'EUR');
TelephoneNumber.setLocalCountryCode(User.getAccountCountry() || 'FR');
Country.setFlagsPath(ROOT_PATH + 'images/flags/');

// Initialize JWT session callbacks
JwtSession.setOnLoginCallback(() => User.login());
JwtSession.setOnLogoutCallback(() => User.logout());
JwtSession.setOnSessionExpireCallback(() => User.logout());

// Initialize HTTP client
const urlSessionExpired = URL_INDEX + '?warning=Votre session a expiré, veuillez vous reconnecter.';
HTTPClient.setRefreshTokenUrl(URL_API + '/refresh');
HTTPClient.setOnInvalidTokenRedirectUrl(urlSessionExpired);
HTTPClient.setOnInvalidRefreshTokenRedirectUrl(urlSessionExpired);
HTTPClient.setAuthorizationToken(JwtSession.getToken());
HTTPClient.setHeader('X-Source', 'mytime.fr');

// Initialize Google Recaptcha
GoogleRecaptcha.setConfig({
	sitekey: GOOGLE_RECAPTCHA_SITE_KEY,
	theme: 'light'
});

//Sentry
if (typeof Sentry != 'undefined') {
	Sentry.init({
		dsn: 'https://741c16651ce941698992785c93f39898@o576843.ingest.sentry.io/5986457',
		ignoreErrors: [
			'TypeError: Failed to fetch', 'TypeError: NetworkError when attempting to fetch resource.', 'TypeError: Not allowed to request resource', 'TypeError: Load failed', 'TypeError: annulé',
			'TypeError: La connexion réseau a été perdue.', 'Error: Could not load "util".', 'SyntaxError: Unexpected token \'<\''
		], integrations: [Sentry.breadcrumbsIntegration({ console: false })],
		// Sentry 11 collecte plus de données par défaut (sendDefaultPii remplacé par dataCollection) : on conserve le comportement restrictif de Sentry 10
		dataCollection: { userInfo: false, cookies: false, httpBodies: [] }
	});
}